import { render } from "./HotspotRenderer.vue?vue&type=template&id=3ff386ce"
import script from "./HotspotRenderer.vue?vue&type=script&lang=js"
export * from "./HotspotRenderer.vue?vue&type=script&lang=js"

import "./HotspotRenderer.vue?vue&type=style&index=0&id=3ff386ce&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\siemens-ecdp-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__